import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { fadeInAnimation } from '../../animations/fade-in.animation';
import { BlockPeriodTypeEnum } from '../../enums/meal-plan';
import { BlockPeriodClass } from '../../class/meal-plan/block-period.class';
import { Subject, takeUntil } from 'rxjs';
import { ICardIconText } from '../../interfaces/card';
import { IIngredientCategory } from 'src/app/interfaces/database/database.interface';
import { Store } from '@ngxs/store';
import { IngredientState } from '../../models/ingredient';
import { MealPlanTypeEnum } from 'src/app/models/meal-plans';
import { MealTimeClass } from 'src/app/class/meal-plan/meal-time.class';
import { INGREDIENT_CATEGORIES_ICONS_B } from 'src/app/class/data';


@Component({
  selector: 'app-card-meal-plan-empty-kanban',
  templateUrl: './card-meal-plan-empty-kanban.component.html',
  styleUrls: ['./card-meal-plan-empty-kanban.component.scss'],
  animations: [fadeInAnimation]
})
export class CardMealPlanEmptyKanbanComponent implements OnInit, OnChanges, OnDestroy {
  blockPeriodTypes: ICardIconText[];
  blockPeriodTypeEnum = BlockPeriodTypeEnum;
  periodTypesIconsMap = {};
  private destroy$ = new Subject<void>();
  categories!: IIngredientCategory[];

  toggleCategoryReq = true;

  @ViewChild('titleInput') titleInput: ElementRef;

  @Input() mealPlanType: MealPlanTypeEnum;
  @Input() clinicId: string;
  @Input() mealTime: MealTimeClass;

  @Output() add: EventEmitter<MealTimeClass> = new EventEmitter();
  @Output() changeMealTime: EventEmitter<{ mealTime: MealTimeClass, action: 'add' | 'edit' | 'delete' | 'cancel' }> = new EventEmitter();

  iconsRoute = './../../../assets/images/icons/ingredients_group/';
  iconsName = INGREDIENT_CATEGORIES_ICONS_B;

  validationChanges = new Subject<void>(); 

  constructor(
    private store: Store,
  ) { }

  async ngOnInit(): Promise<void> {
    // Tipos de block period
    this.blockPeriodTypes = [
      {
        id: this.blockPeriodTypeEnum.FOOD_GROUP,
        label: 'Platillo',
        img: './../../../assets/images/icons/icons8-food-100-2.png'
      },
      {
        id: this.blockPeriodTypeEnum.INDIVIDUAL,
        label: 'Individual',
        img: './../../../assets/images/icons/icons8-tomato-100.png'
      },
      {
        id: this.blockPeriodTypeEnum.INSTRUCTION,
        label: 'instrucciones',
        img: './../../../assets/images/icons/icons8-book-100.png'
      }
    ];

    this.periodTypesIconsMap[this.blockPeriodTypeEnum.FOOD_GROUP] = './../../../assets/images/icons/icons8-food-100-2.png';
    this.periodTypesIconsMap[this.blockPeriodTypeEnum.INDIVIDUAL] = './../../../assets/images/icons/icons8-tomato-100.png';
    this.periodTypesIconsMap[this.blockPeriodTypeEnum.INSTRUCTION] = './../../../assets/images/icons/icons8-book-100.png';

    setTimeout(() => {
      this.titleInput?.nativeElement.focus();
    }, 200);

    this.store.select(IngredientState.getIngredientCategories).pipe(
      takeUntil(this.destroy$)
    ).subscribe(categories => this.categories = categories);

    this.mealTime.isValid();
  }


  /**
   * Detecta cuando se cambia la propiedad blockPeriod para establecerle los datos y mostrarlos.
   * @param changes cambios
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.mealTime) return;
    if (!this.mealTime._id) this.mealTime.setId(''); // GuidService removed, using empty string for now
  }


  /**
   * cuando se cancela se determina si era en modo edición, en ese caso se regresan los valores a como estaban al principio
   * en el otro caso es cuando aún no se ha agregado un block period y se cancela
   */
  onCancel(): void {
    this.changeMealTime.emit({ mealTime: this.mealTime, action: 'cancel' });
  }


  /**
   * Establece si el blokperiod tiene hora o no
   */
  onSetHasTime(time: Date): void {
    if (time) {
      this.mealTime.setTime({
        hour: time.getHours(),
        minute: time.getMinutes()
      });
    }
    this.mealTime.setHasHour(!!time);
  }

  /**
   * Emite al componente padre cuando se quiere agregar un nuevo block period o se modifica.
   */
  async onEmitPutMealTime(): Promise<void> {
    this.changeMealTime.emit({ mealTime: this.mealTime, action: 'edit' });
    this.toggleCategoryReq = false;
    setTimeout(() => {this.toggleCategoryReq = true;}, 0);
    this.mealTime.syncNutritionalProperties();
  }

  async onSave(): Promise<void> {
    if (!this.mealTime.isValid()) return;

    if (this.mealTime.editMode) {
      this.changeMealTime.emit({ mealTime: this.mealTime, action: 'edit' });
      this.mealTime.setEditMode(false);
      return;
    }
  }


  deleteBlock(index: number) {
    if (index >= 0 && index < this.mealTime.blockPeriods.length) {
      this.mealTime.blockPeriods.splice(index, 1);
    } else {
      console.error('Index out of bounds');
    }
  }


  addBlock(type: BlockPeriodTypeEnum) {
    const newChildBlock = new BlockPeriodClass();
    newChildBlock.setType(type);

    const titles = {
      [BlockPeriodTypeEnum.FOOD_GROUP]: "Nuevo platillo",
      [BlockPeriodTypeEnum.INSTRUCTION]: "Nuevas instrucciones",
      [BlockPeriodTypeEnum.INDIVIDUAL]: "Nuevo ingrediente"
    };

    const title = titles[type] || "Nuevo bloque";
    newChildBlock.setTitle(title);

    this.mealTime.blockPeriods.push(newChildBlock);
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}